module.exports = require("react-ace");


//////////////////
// WEBPACK FOOTER
// external "react-ace"
// module id = 231
// module chunks = 0